// src/App.tsx
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import AcessoZap from './components/zap';
import WhatsAppLink from './components/api/zapLink';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './components/devtools';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <div className="container">
          <div className="content">
            <div id="acesso">
              <Routes>
                <Route path="/" element={<AcessoZap />} />
                <Route path="/api/zapLink" element={<WhatsAppLink />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
